import { WarningFilled } from "@ant-design/icons";
import { Button } from "antd";
import styled from "styled-components";

export const StyledWarningTriangle = styled(WarningFilled)`
    font-size: 24px;
    color: ${({ theme }) => theme.alertColor};
    position: absolute;
    left: 17px;
    top: 17px;
`;

export const StyledConfirmButton = styled(Button)`
    height: 50px;
    border-radius: 50px;
    width: 100%;
    font-size: 16px;
    margin-top: 24px;
    font-weight: 400;
`;
